
module.exports = require('./socket');

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = require('engine.io-parser');



//////////////////
// WEBPACK FOOTER
// ./~/engine.io-client/lib/index.js
// module id = 1097
// module chunks = 22